import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a38b586"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "font-size": "18px",
    "padding": "0px 20px"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column",
    "overflow": "hidden",
    "padding": "0px 20px"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "overflow-y": "auto"
  }
};
const _hoisted_6 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column",
    "overflow": "hidden"
  }
};
const _hoisted_7 = {
  style: {
    "height": "60px",
    "display": "flex",
    "align-items": "end",
    "justify-content": "end",
    "gap": "22px"
  }
};
const _hoisted_8 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit", -1));
const _hoisted_10 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { ref, reactive, onMounted, getCurrentInstance, h, nextTick, createVNode } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message, notification } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import { ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
export default {
  __name: 'CreateInteraction',
  setup(__props) {
    const {
      t,
      locale
    } = useI18n(); // 获取 locale 引用

    // 引入组件
    const components = {
      DownCircleOutlined,
      PlusOutlined
    };
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const itemId = route.params.itemId;
    const activityColumnData = reactive([]);

    // 初始化数据和方法
    const activityStatsForm = ref(null);
    const activityStatsFormData = reactive({
      name: "",
      itemName: "",
      activityStatsTypeId: null,
      activityStatsWeekId: null,
      activityStatsYear: null,
      activityStatsDate: null,
      activityStatsBegin: null,
      activityStatsEnd: null,
      remark: null,
      itemNameOnly: true
    });
    const activityColumnForm = ref(null);
    const activityColumnFormData = reactive({
      title: "",
      name: "",
      type: null,
      required: null,
      length: null,
      scale: null
    });
    var editColumn = null;
    var removeColumns = [];
    var cloneActivityStatsFormData = null;
    var cloneActivityColumnData = null;
    onMounted(async () => {
      let statsTypes = await getActivityStatsTypeRequest();
      statsTypeOptions.value.push(...statsTypes.map(statsType => ({
        value: statsType.activityStatsTypeId,
        label: statsType.activityStatsTypeName
      })));
      let statsWeeks = await getActivityStatsWeekRequest();
      statsWeekOptions.value.push(...statsWeeks.map(statsWeek => ({
        value: statsWeek.activityStatsWeekId,
        label: statsWeek.activityStatsWeekName
      })));
      if (itemId) {
        let columnData = await getActivityColumnRequest(itemId);
        if (Array.isArray(columnData)) {
          activityColumnData.push(...columnData.filter(column => column.name !== "store_name"));
        }
        let activityStatsItem = await getActivityStatsItemRequest(itemId);
        util.propertyClone(activityStatsItem, activityStatsFormData);
        activityStatsFormData.name = activityStatsItem.activityStatsName;
        activityStatsFormData.itemName = activityStatsItem.activityStatsItemName;
        activityStatsFormData.activityStatsBegin = dayjs(activityStatsItem.activityStatsBegin, "YYYY-MM-DD");
        if (activityStatsFormData.activityStatsEnd) {
          activityStatsFormData.activityStatsEnd = dayjs(activityStatsItem.activityStatsEnd, "YYYY-MM-DD");
        }
        // activityStatsFormData.activityStatsDate = [
        //   dayjs(activityStatsItem.activityStatsBegin, "YYYY-MM-DD"),
        //   dayjs(activityStatsItem.activityStatsEnd, "YYYY-MM-DD"),
        // ];

        cloneActivityStatsFormData = JSON.stringify(activityStatsFormData);
        cloneActivityColumnData = JSON.stringify(activityColumnData);
      }
    });
    const activityColumnTable = ref(null);
    const columnTypeOptions = ref([{
      value: "varchar",
      label: "varchar"
    }, {
      value: "text",
      label: "text"
    }, {
      value: "bigint",
      label: "bigint"
    }, {
      value: "int",
      label: "int"
    }, {
      value: "double",
      label: "double"
    }, {
      value: "float",
      label: "float"
    }, {
      value: "decimal",
      label: "decimal"
    }, {
      value: "date",
      label: "date"
    }, {
      value: "datetime",
      label: "datetime"
    }]);
    const requiredOptions = ref([{
      value: true,
      label: t('createInteraction.yes')
    }, {
      value: false,
      label: t('createInteraction.no')
    }]);
    const statsYearOptions = ref([{
      value: "2022",
      label: "2022"
    }, {
      value: "2023",
      label: "2023"
    }, {
      value: "2024",
      label: "2024"
    }, {
      value: "2025",
      label: "2025"
    }, {
      value: "2026",
      label: "2026"
    }, {
      value: "2027",
      label: "2027"
    }, {
      value: "2028",
      label: "2028"
    }]);
    const statsTypeOptions = ref([]);
    const statsWeekOptions = ref([]);
    const activityColumnOpen = ref(false);
    const activityColumnValidRules = ref({
      title: [{
        required: true,
        message: t('createInteraction.inputFieldTitle'),
        tooltip: true
      }],
      name: [{
        required: true,
        message: t('createInteraction.inputFieldName')
      }],
      type: [{
        required: true,
        message: t('createInteraction.selectFieldType')
      }],
      required: [{
        required: true,
        message: t('createInteraction.selectFieldRequired')
      }],
      length: [{
        validator(rule, value) {
          if (!value && ["varchar", "decimal", "double", "float"].includes(activityColumnFormData.type)) {
            return Promise.reject(t('createInteraction.inputLength'));
          }
          return Promise.resolve();
        }
      }]
    });
    // 点击下一步
    const validAllEvent = async () => {
      console.log(itemId);
      if (itemId != null) {
        const formString = JSON.stringify(activityStatsFormData);
        const columnString = JSON.stringify(activityColumnData);
        console.log(formString);
        console.log(cloneActivityStatsFormData);
        console.log(columnString);
        console.log(cloneActivityColumnData);
        if (formString === cloneActivityStatsFormData && columnString === cloneActivityColumnData) {
          router.push({
            path: "/test-interaction/" + itemId
          });
          return;
        }
      }
      activityStatsForm.value.validate().then(async () => {
        if (activityColumnData == null || activityColumnData.length === 0) {
          notification.error({
            message: t('createInteraction.error'),
            description: t('createInteraction.noFieldData')
          });
          return;
        }
        let findIndex = activityColumnData.findIndex(element => element.name == "store_code" && element.type == "varchar" && element.required == true && element.length == 50);
        if (findIndex == -1) {
          notification.error({
            message: t('createInteraction.error'),
            description: t('createInteraction.requiredFieldRule')
          });
          return;
        }
        let activityStatsParam = JSON.parse(JSON.stringify(activityStatsFormData));
        activityStatsParam.activityStatsBegin = dayjs(activityStatsFormData.activityStatsBegin).format("YYYY-MM-DD");
        if (activityStatsFormData.activityStatsEnd) {
          activityStatsParam.activityStatsEnd = dayjs(activityStatsFormData.activityStatsEnd).format("YYYY-MM-DD");
        }
        if (itemId == null || itemId == "") {
          activityStatsParam.columns = activityColumnData;
          createActivityStats(activityStatsParam);
        } else {
          activityStatsParam.itemId = itemId;
          activityStatsParam.columns = activityColumnData.filter(object => object.operation != null);

          // for (let removeColumn of removeColumns) {
          //   activityStatsParam.columns.push({
          //     oldName: removeColumn.name,
          //     operation: 3,
          //   });
          // }
          modifyActivityStats(activityStatsParam);
        }
      }).catch(error => {
        console.log("error", error);
      });
    };
    const onCancel = () => {
      router.go(-1);
    };
    const getActivityStatsItemRequest = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsItem(itemId).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t('createInteraction.error'),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityColumnRequest = async itemId => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityColumn(itemId).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t('createInteraction.error'),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // 创建活动
    const createActivityStats = async activityStatsCreate => {
      proxy.$api.activityStatsRequest.createActivityStats(activityStatsCreate).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "1000") {
            ElNotification({
              title: "Success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            router.push({
              path: "/test-interaction/" + res.result.data.itemId
            });
          } else {
            ElNotification({
              title: "Failure",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: "Failure",
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "Error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    // 修改活动
    const modifyActivityStats = async activityStatsModify => {
      proxy.$api.activityStatsRequest.modifyActivityStats(activityStatsModify).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "1200") {
            ElNotification({
              title: "Success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
            router.push({
              path: "/test-interaction/" + activityStatsModify.itemId
            });
          } else {
            ElNotification({
              title: "Failure",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 3000
            });
          }
        } else {
          ElNotification({
            title: "Failure",
            message: res.msg,
            type: "error",
            duration: 3000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "Error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const addActivityColumn = () => {
      editColumn = null;
      activityColumnOpen.value = true;
    };
    const editActivityColumn = row => {
      editColumn = JSON.parse(JSON.stringify(row));
      util.propertyClone(row, activityColumnFormData);
      activityColumnOpen.value = true;
      console.log('修改');
    };
    const removeActivityColumn = row => {
      Modal.confirm({
        title: t('createInteraction.tip'),
        icon: createVNode(ExclamationCircleOutlined),
        okButtonProps: {
          class: "sts-button default",
          style: "height:22px"
        },
        cancelButtonProps: {
          class: "sts-button default",
          style: "height:22px"
        },
        zIndex: 1002,
        content: locale.value === "zh" ? "要删除字段[" + row.title + "]吗？" : "Are you sure you want to delete the field [" + row.title + "]?",
        okText: t('createInteraction.confirm'),
        cancelText: t('createInteraction.cancel'),
        // onOk() {
        //   const $table = activityColumnTable.value;
        //   if ($table) {
        //     $table.remove(row);
        //     let findIndex = activityColumnData.findIndex(
        //       (element) => element.name == row.name
        //     );
        //     if (activityColumnData[findIndex].operation == null) {
        //       removeColumns.push(row);
        //     }
        //   }
        //   console.log("删除");
        // },
        onOk() {
          // 从表格中移除行
          const $table = activityColumnTable.value;
          if ($table) {
            $table.remove(row);
          }

          // 找到activityColumnData中的对应项并标记为删除
          let findIndex = activityColumnData.findIndex(element => element.name == row.name);
          if (findIndex !== -1) {
            if (activityColumnData[findIndex].operation == null) {
              // 如果是新增后又删除的项，直接从数组中移除
              if (activityColumnData[findIndex].operation === 1) {
                activityColumnData.splice(findIndex, 1);
              } else {
                // 对于已有数据的删除，标记operation为3（表示删除） oldName
                activityColumnData[findIndex].operation = 3;
                activityColumnData[findIndex].oldName = activityColumnData[findIndex].name;
                // 添加到待删除数组
                removeColumns.push({
                  ...activityColumnData[findIndex]
                }); // 注意这里复制对象避免引用问题
              }
            } else {
              // 如果已经有操作标记
              if (activityColumnData[findIndex].operation === 1) {
                // 如果是新增状态，则直接删除
                activityColumnData.splice(findIndex, 1);
              } else {
                // 如果是修改状态，则标记为删除
                activityColumnData[findIndex].operation = 3;
                activityColumnData[findIndex].oldName = activityColumnData[findIndex].name;
                removeColumns.push({
                  ...activityColumnData[findIndex]
                });
              }
            }
          }
          console.log("删除完成", activityColumnData, removeColumns);
        }
      });
    };
    const getActivityStatsTypeRequest = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsType(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t('createInteraction.error'),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityStatsWeekRequest = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsWeek(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t('createInteraction.error'),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const onActivityColumnCancel = () => {
      activityColumnForm.value.resetFields();
      activityColumnOpen.value = false;
    };
    const onActivityColumnSave = () => {
      activityColumnForm.value.validate().then(async () => {
        let column = JSON.parse(JSON.stringify(activityColumnFormData));
        if (editColumn == null) {
          column.operation = 1;
          activityColumnData.push(column);
        } else {
          let findIndex = activityColumnData.findIndex(element => element.name == editColumn.name);
          util.propertyClone(column, activityColumnData[findIndex]);
          if (activityColumnData[findIndex].operation == null) {
            activityColumnData[findIndex].oldName = editColumn.name;
            activityColumnData[findIndex].operation = 2;
          }
        }
        activityColumnForm.value.resetFields();
        activityColumnOpen.value = false;
      }).catch(error => {
        console.log("error", error);
      });
    };
    return (_ctx, _cache) => {
      const _component_a_divider = _resolveComponent("a-divider");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("createInteraction.activityInfo")), 1), _createVNode(_component_a_divider), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_form, {
        model: activityStatsFormData,
        ref_key: "activityStatsForm",
        ref: activityStatsForm,
        class: "sts-form",
        labelAlign: "left",
        autocomplete: "off",
        labelCol: {
          flex: '0 0 100px'
        },
        style: {
          "margin-top": "20px",
          "flex": "1"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_row, null, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: _ctx.$t('createInteraction.activityType'),
              name: "activityStatsTypeId",
              rules: [{
                required: true,
                message: _ctx.$t('createInteraction.selectActivityType')
              }]
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select, {
                dropdownMatchSelectWidth: false,
                options: statsTypeOptions.value,
                popupClassName: "sts-select-dropdown",
                style: {
                  "max-width": "262px"
                },
                value: activityStatsFormData.activityStatsTypeId,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => activityStatsFormData.activityStatsTypeId = $event)
              }, {
                suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                  class: "ant-select-suffix"
                })]),
                _: 1
              }, 8, ["options", "value"])]),
              _: 1
            }, 8, ["label", "rules"]), _createVNode(_component_a_row, null, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                span: 9
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: _ctx.$t('createInteraction.interactionName'),
                  name: "activityStatsWeekId",
                  rules: [{
                    required: true,
                    message: _ctx.$t('createInteraction.selectActivityType')
                  }],
                  labelCol: {
                    flex: '0 0 100px'
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    dropdownMatchSelectWidth: false,
                    options: statsWeekOptions.value,
                    popupClassName: "sts-select-dropdown",
                    value: activityStatsFormData.activityStatsWeekId,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => activityStatsFormData.activityStatsWeekId = $event)
                  }, {
                    suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                      class: "ant-select-suffix"
                    })]),
                    _: 1
                  }, 8, ["options", "value"])]),
                  _: 1
                }, 8, ["label", "rules"])]),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "activityStatsYear",
                  rules: [{
                    required: true,
                    message: _ctx.$t('createInteraction.selectActivityType')
                  }],
                  style: {
                    "margin-left": "21px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    dropdownMatchSelectWidth: false,
                    options: statsYearOptions.value,
                    popupClassName: "sts-select-dropdown",
                    value: activityStatsFormData.activityStatsYear,
                    "onUpdate:value": _cache[2] || (_cache[2] = $event => activityStatsFormData.activityStatsYear = $event)
                  }, {
                    suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                      class: "ant-select-suffix"
                    })]),
                    _: 1
                  }, 8, ["options", "value"])]),
                  _: 1
                }, 8, ["rules"])]),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 9
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "name",
                  rules: [{
                    required: true,
                    message: _ctx.$t('createInteraction.inputActivityName')
                  }],
                  style: {
                    "margin-left": "21px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    value: activityStatsFormData.name,
                    "onUpdate:value": _cache[3] || (_cache[3] = $event => activityStatsFormData.name = $event)
                  }, null, 8, ["value"])]),
                  _: 1
                }, 8, ["rules"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, null, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                span: 15
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: _ctx.$t('createInteraction.subProject'),
                  name: "itemName",
                  rules: [{
                    required: true,
                    message: _ctx.$t('createInteraction.inputSubProject')
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    value: activityStatsFormData.itemName,
                    "onUpdate:value": _cache[4] || (_cache[4] = $event => activityStatsFormData.itemName = $event)
                  }, null, 8, ["value"])]),
                  _: 1
                }, 8, ["label", "rules"])]),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 9
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "itemNameOnly"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                    style: {
                      "margin-left": "20px"
                    },
                    checked: activityStatsFormData.itemNameOnly,
                    "onUpdate:checked": _cache[5] || (_cache[5] = $event => activityStatsFormData.itemNameOnly = $event)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('createInteraction.showOnlySubProject')), 1)]),
                    _: 1
                  }, 8, ["checked"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, null, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                span: 9
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: _ctx.$t('createInteraction.activityTime'),
                  name: "activityStatsBegin",
                  rules: [{
                    required: true,
                    message: _ctx.$t('createInteraction.selectActivityTime')
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                    popupClassName: "sts-picker",
                    class: "sts-picker",
                    value: activityStatsFormData.activityStatsBegin,
                    "onUpdate:value": _cache[6] || (_cache[6] = $event => activityStatsFormData.activityStatsBegin = $event),
                    style: {
                      "width": "100%"
                    },
                    placeholder: _ctx.$t('createInteraction.selectDate')
                  }, null, 8, ["value", "placeholder"])]),
                  _: 1
                }, 8, ["label", "rules"])]),
                _: 1
              }), _createVNode(_component_a_col, {
                span: 15
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "activityStatsEnd"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                    popupClassName: "sts-picker",
                    class: "sts-picker",
                    value: activityStatsFormData.activityStatsEnd,
                    "onUpdate:value": _cache[7] || (_cache[7] = $event => activityStatsFormData.activityStatsEnd = $event),
                    style: {
                      "width": "152px",
                      "margin-left": "21px"
                    },
                    placeholder: _ctx.$t('createInteraction.selectDate')
                  }, null, 8, ["value", "placeholder"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: _ctx.$t('createInteraction.activityNote'),
              name: "remark",
              "label-col": {
                span: 3
              },
              "wrapper-col": {
                span: 20
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_textarea, {
                "auto-size": {
                  minRows: 10
                },
                value: activityStatsFormData.remark,
                "onUpdate:value": _cache[8] || (_cache[8] = $event => activityStatsFormData.remark = $event)
              }, null, 8, ["value"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_config_provider, {
        theme: {
          components: {
            Button: {
              controlHeight: 24
            },
            Select: {
              fontSizeIcon: 18
            }
          }
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_table, {
          stripe: "",
          height: "auto",
          data: activityColumnData,
          ref_key: "activityColumnTable",
          ref: activityColumnTable,
          class: "sts-table",
          "keep-source": "",
          "empty-text": _ctx.$t('createInteraction.noData')
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "title",
            title: _ctx.$t('createInteraction.fieldTitle'),
            "edit-render": {
              autofocus: '.ant-input'
            }
          }, null, 8, ["title", "edit-render"]), _createVNode(_component_vxe_column, {
            field: "name",
            title: _ctx.$t('createInteraction.fieldName'),
            "edit-render": {
              autofocus: '.ant-input'
            }
          }, null, 8, ["title", "edit-render"]), _createVNode(_component_vxe_column, {
            "max-width": "200",
            field: "type",
            title: _ctx.$t('createInteraction.fieldType'),
            "edit-render": {
              autofocus: 'ant-select-selection-search-input'
            }
          }, null, 8, ["title"]), _createVNode(_component_vxe_column, {
            "max-width": "200",
            field: "required",
            title: _ctx.$t('createInteraction.isRequired'),
            "edit-render": {
              autofocus: 'ant-select-selection-search-input',
              options: requiredOptions.value
            }
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", null, _toDisplayString(row.required ? _ctx.$t('createInteraction.yes') : _ctx.$t('createInteraction.no')), 1)]),
            _: 1
          }, 8, ["title", "edit-render"]), _createVNode(_component_vxe_column, {
            "max-width": "200",
            field: "length",
            title: _ctx.$t('createInteraction.length'),
            "edit-render": {
              autofocus: '.ant-input-number-input'
            }
          }, null, 8, ["title", "edit-render"]), _createVNode(_component_vxe_column, {
            "max-width": "200",
            field: "scale",
            title: _ctx.$t('createInteraction.decimalPlaces'),
            "edit-render": {
              autofocus: '.ant-input-number-input'
            }
          }, null, 8, ["title", "edit-render"]), _createVNode(_component_vxe_column, {
            width: "100",
            field: "action",
            title: ""
          }, {
            header: _withCtx(({}) => [_createVNode(_component_a_button, {
              onClick: addActivityColumn,
              class: "sts-button-circle-icon default",
              shape: "circle"
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                iconName: "tk_plus",
                iconColor: '#777777',
                iconSize: "16px"
              })]),
              _: 1
            })]),
            default: _withCtx(({
              row
            }) => [_createVNode(_component_a_dropdown, {
              overlayClassName: "sts-dropdown",
              trigger: ['click']
            }, {
              overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
                default: _withCtx(() => [_createVNode(_component_a_menu_item, {
                  key: "0",
                  onClick: $event => editActivityColumn(row)
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('createInteraction.edit')), 1)]),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_component_a_menu_item, {
                  key: "1",
                  onClick: $event => removeActivityColumn(row)
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('createInteraction.delete')), 1)]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              default: _withCtx(() => [_createVNode(_component_a_button, {
                class: "sts-button-circle-icon default",
                shape: "circle",
                disabled: _unref(itemId) != null && _unref(itemId) != '' && row.name === 'store_code'
              }, {
                default: _withCtx(() => [_createVNode(_component_svg_icon, {
                  iconName: "more",
                  iconColor: '#777777',
                  iconSize: "16px"
                })]),
                _: 2
              }, 1032, ["disabled"])]),
              _: 2
            }, 1024)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "empty-text"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_button, {
        onClick: validAllEvent,
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('createInteraction.nextStep')), 1)]),
        _: 1
      }), _createVNode(_component_a_button, {
        onClick: onCancel,
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('createInteraction.cancel')), 1)]),
        _: 1
      })])])])]), _createVNode(_component_a_modal, {
        open: activityColumnOpen.value,
        "onUpdate:open": _cache[15] || (_cache[15] = $event => activityColumnOpen.value = $event),
        closable: false,
        width: "1150px",
        onOk: _ctx.handleOk,
        zIndex: "1001",
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onActivityColumnCancel
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('createInteraction.cancel')), 1)]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: onActivityColumnSave
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('createInteraction.confirm')), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: activityColumnFormData,
          ref_key: "activityColumnForm",
          ref: activityColumnForm,
          class: "sts-form",
          "label-col": {
            span: 24
          },
          "wrapper-col": {
            span: 24
          },
          "label-align": "left",
          autocomplete: "off",
          layout: "inline",
          rules: activityColumnValidRules.value
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: _ctx.$t('createInteraction.fieldTitle'),
            name: "title",
            style: {
              "width": "250px"
            },
            rules: [{
              required: true,
              message: _ctx.$t('createInteraction.inputFieldTitle')
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: activityColumnFormData.title,
              "onUpdate:value": _cache[9] || (_cache[9] = $event => activityColumnFormData.title = $event)
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('createInteraction.fieldName'),
            name: "name",
            style: {
              "width": "250px"
            },
            rules: [{
              required: true,
              message: _ctx.$t('createInteraction.inputFieldName')
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: activityColumnFormData.name,
              "onUpdate:value": _cache[10] || (_cache[10] = $event => activityColumnFormData.name = $event)
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('createInteraction.fieldType'),
            name: "type",
            style: {
              "width": "120px"
            },
            rules: [{
              required: true,
              message: _ctx.$t('createInteraction.selectFieldType')
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              dropdownMatchSelectWidth: false,
              options: columnTypeOptions.value,
              popupClassName: "sts-select-dropdown",
              value: activityColumnFormData.type,
              "onUpdate:value": _cache[11] || (_cache[11] = $event => activityColumnFormData.type = $event)
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix"
              })]),
              _: 1
            }, 8, ["options", "value"])]),
            _: 1
          }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('createInteraction.isRequired'),
            name: "required",
            style: {
              "width": "120px"
            },
            rules: [{
              required: true,
              message: _ctx.$t('createInteraction.selectFieldType')
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              dropdownMatchSelectWidth: false,
              options: requiredOptions.value,
              popupClassName: "sts-select-dropdown",
              value: activityColumnFormData.required,
              "onUpdate:value": _cache[12] || (_cache[12] = $event => activityColumnFormData.required = $event)
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix"
              })]),
              _: 1
            }, 8, ["options", "value"])]),
            _: 1
          }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('createInteraction.length'),
            name: "length",
            style: {
              "width": "120px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              value: activityColumnFormData.length,
              "onUpdate:value": _cache[13] || (_cache[13] = $event => activityColumnFormData.length = $event),
              min: 0,
              max: 100000,
              style: {
                "width": "100%"
              }
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('createInteraction.decimalPlaces'),
            name: "scale",
            style: {
              "width": "120px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: activityColumnFormData.scale,
              "onUpdate:value": _cache[14] || (_cache[14] = $event => activityColumnFormData.scale = $event)
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open", "onOk"])], 64);
    };
  }
};